module.exports = __webpack_public_path__ + "static/media/down_arrow.3b8df7c8.svg";